import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { MessagesService } from "../../services/messages.service";
import { MessageActions } from "./message.actions";
import { StartCourseMessage } from "../../models/start-course-message.model";
import { EventMessage } from "../../models/event-message.model";

export class MessageModel {
  public engagementMessages: EventMessage[];
  public contractMessages: StartCourseMessage[];
  public error: string;
}

const defaults = {
  engagementMessages: [],
  contractMessages: [],
  error: '',
};

@State<MessageModel>({
  name: 'message',
  defaults,
})
@Injectable()
export class MessageState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    public store: Store,
    private messagesService: MessagesService,
  ) {}

  @Action(MessageActions.GetContractMessages) getContractMessages(ctx: StateContext<MessageModel>, {currentDate, enventName}: MessageActions.GetContractMessages) {
    return this.messagesService.getStartCourseMessages(currentDate, enventName).subscribe({
      next: (response) =>
        ctx.dispatch(new MessageActions.GetContractMessagesSuccess(response)),
      error: (error) =>
        ctx.dispatch(new MessageActions.Error(error)),
    });
  }

  @Action(MessageActions.GetContractMessagesSuccess) getContractMessagesSuccess(ctx: StateContext<MessageModel>, {contractMessages}: MessageActions.GetContractMessagesSuccess) {
    ctx.patchState({
      contractMessages: contractMessages.sort((a, b) => new Date(b.eventCreation).getTime() - new Date(a.eventCreation).getTime())
    });
  }

  @Action(MessageActions.GetEngagementMessages) getEngagementMessages(ctx: StateContext<MessageModel>, {currentDate, enventName}: MessageActions.GetEngagementMessages) {
    return this.messagesService.getEventMessages(currentDate, enventName).subscribe({
      next: (response) =>
        ctx.dispatch(new MessageActions.GetEngagementMessagesSuccess(response)),
      error: (error) =>
        ctx.dispatch(new MessageActions.Error(error)),
    });
  }

  @Action(MessageActions.GetEngagementMessagesSuccess) getEngagementMessagesSuccess(ctx: StateContext<MessageModel>, {engagementMessages}: MessageActions.GetEngagementMessagesSuccess) {
    ctx.patchState({
      engagementMessages: engagementMessages.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
    });
  }

  @Action(MessageActions.Error)
  onErrorOcurred(ctx: StateContext<MessageModel>, { error }: MessageActions.Error
  ) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('labels.messages');
  }
}
